import { createRoute, redirect } from '@tanstack/react-router';
import { ManagementOverviewPage } from '@/modules/management/ManagementOverviewPage';
import {
  LEGACY_PLATFORMA_TABS,
  parseManagementSearch,
  type LegacyPlatformaTab,
} from '@/modules/management/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/management',
  component: ManagementOverviewPage,
  validateSearch: parseManagementSearch,
  // Uživatelé / Firmy / Záznamy úloh moved to /platforma — keep old links working.
  beforeLoad: ({ search }) => {
    if (search.tab && search.tab in LEGACY_PLATFORMA_TABS) {
      throw redirect({
        to: '/platforma',
        search: { tab: LEGACY_PLATFORMA_TABS[search.tab as LegacyPlatformaTab] },
        replace: true,
      });
    }
  },
});
